import { Style } from 'index';

const ImportCreateStub: Style = {
    textInput: {
        width: '100%',
        paddingBottom: '1rem',
    },
};

export default ImportCreateStub;
